import React, { memo } from "react";
import FloatingMessageActions from "../FloatingMessageActions";

// ErrorBoundary para capturar erros em CallLogMessage
class CallLogErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('❌ Erro no CallLogMessage:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '8px', 
          backgroundColor: '#ffebee', 
          borderRadius: '4px',
          color: '#c62828',
          fontSize: '12px',
          textAlign: 'center'
        }}>
          ⚠️ Erro ao exibir chamada perdida
        </div>
      );
    }

    return this.props.children;
  }
}

/**
 * Componente para exibir mensagens de log de chamadas (chamadas perdidas)
 */
const CallLogMessage = memo(({
  message,
  index,
  isGroup,
  classes,
  renderTicketsSeparator,
  renderMessageDivider,
  formatMessageTime,
  i18n
}) => {  return (
    <CallLogErrorBoundary>
      <React.Fragment>
        {renderTicketsSeparator && renderTicketsSeparator(message, index)}
        {renderMessageDivider && renderMessageDivider(message, index)}
        <div className={classes.messageCenter}>
          {/* 🎯 FloatingMessageActions - Sistema moderno de ações */}
          <FloatingMessageActions
            message={message}
            canEdit={false}
            canForward={true}
            canReply={true}
            onReaction={() => {}}
            onEdit={() => {}}
            onDelete={() => {}}
            onForward={() => {}}
            onReply={() => {}}
          />
          
          {isGroup && (
            <span className={classes.messageContactName}>
              {message.contact?.name}
            </span>
          )}

          <div>
            {/* Ícone de chamada perdida */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 17"
              width="20"
              height="17"
            >
              <path
                fill="#df3333"
                d="M18.2 12.1c-1.5-1.8-5-2.7-8.2-2.7s-6.7 1-8.2 2.7c-.7.8-.3 2.3.2 2.8.2.2.3.3.5.3 1.4 0 3.6-.7 3.6-.7.5-.2.8-.5.8-1v-1.3c.7-1.2 5.4-1.2 6.4-.1l.1.1v1.3c0 .2.1.4.2.6.1.2.3.3.5.4 0 0 2.2.7 3.6.7.2 0 1.4-2 .5-3.1zM5.4 3.2l4.7 4.6 5.8-5.7-.9-.8L10.1 6 6.4 2.3h2.5V1H4.1v4.8h1.3V3.2z"
              />
            </svg>{" "}
            
            <span>
              {i18n && i18n.t ? i18n.t("ticketsList.missedCall") : "Chamada perdida"}{" "}
              {formatMessageTime && formatMessageTime(message.createdAt)}
            </span>
          </div>
        </div>
      </React.Fragment>
    </CallLogErrorBoundary>
  );
});

CallLogMessage.displayName = "CallLogMessage";

export default CallLogMessage;
